<template>
  <div class="users">
    <Header :isbig="true" @handleLogin="handleLogin"></Header>
    <Model v-show="modelShow" :type="qdnum" :modelShow.sync="modelShow"></Model>
    <div class="user2">
      <!-- 内容 -->
      <div class="container">
        <div class="user-left">
          <div class="avatar">
            <p class="avatar-holder"></p>
          </div>
          <p class="user-name">
            <span>{{ userInfo.name }}</span>
            <!--					<img src="../assets/icon_bianji@2x.png" style="width:22px; height:22px;margin-top: 8px;margin-left: 5px;cursor: pointer;" alt="">-->
          </p>
          <p class="user-des" v-if="!userInfo.vip_expired_at">
            开通VIP，全站影片免费观看
          </p>
          <p class="user-des" v-else>
            VIP到期时间：{{ userInfo.vip_expired_at }}
          </p>
          <p class="user-opt">
            <span @click="qiehuan()">切换</span>
            <span @click="tuichu()">退出</span>
          </p>

          <p class="user-btn" @click="openNpmber()">
            充值中心
          </p>
          <ul class="menus">
            <li
              @click="handleChange(item.type)"
              v-for="(item, index) in menuList"
              :class="actType == item.type && 'item-active'"
              :key="item.name + index"
            >
              <img :src="actType == item.type ? item.aimg : item.img" alt="" />
              <p>{{ item.name }}</p>
            </li>
          </ul>
        </div>
        <div class="user-right">
          <div v-show="actType == 1 || actType == 2" class="his-wra">
            <div class="his-no" v-if="hisList.length <= 0">
              <!-- 暂无{{
                actType == 1 ? "观看历史" : actType == 2 ? "收藏记录" : ""
              }} -->
            </div>
          </div>
          <div v-show="actType == 1" style="width:1264px;height:966px">
            <iframe
              src="/service.html"
              width="1300px"
              height="1000px"
              scrolling="auto"
              frameborder="no"
              border="0"
            ></iframe>
          </div>

          <!-- <div v-show="actType == 8">
            <p class="act-title">{{ selfTrial.title }}</p>
            <div v-for="(item, index) of selfTrial.data" :key="index">
              <p>{{ item.nav }}</p>
              <p style="text-indent:2rem">{{ item.article }}</p>
            </div>
          </div> -->
          <div v-show="actType == 8" style="width:1264px;height:966px">
            <iframe
              src="/audit.html"
              width="1300px"
              height="1000px"
              scrolling="auto"
              frameborder="no"
              border="0"
            ></iframe>
          </div>
          <div v-show="actType == 7" style="width:1264px;height:966px">
            <iframe
              src="/refund.html"
              width="1300px"
              height="1000px"
              scrolling="auto"
              frameborder="no"
              border="0"
            ></iframe>
          </div>
          <div v-show="actType == 2" style="width:1264px;height:966px">
            <iframe
              src="/policy.html"
              width="1300px"
              height="1000px"
              scrolling="auto"
              frameborder="no"
              border="0"
            ></iframe>
          </div>
          <div v-show="actType == 3">
            <div class="PayList">
              <div class="item">
                <span>商品名称</span>
                <span>支付渠道</span>
                <span>购买日期</span>
                <span>消费金额</span>
                <span>订单状态</span>
              </div>
              <template v-if="ordersList.length > 0">
                <div
                  class="item"
                  v-for="item in ordersList"
                  :key="item.created_at"
                >
                  <span style="color: #999999">{{ item.mark }}</span>
                  <span style="color: #999999">{{
                    item.paid_channel == 0
                      ? "微信"
                      : item.paid_channel == 1
                      ? "支付宝"
                      : "未知"
                  }}</span>
                  <span style="color: #999999">{{ item.created_at }}</span>
                  <span style="color: #999999">{{
                    (item.amount * 0.01).toFixed(2)
                  }}</span>
                  <span style="color: #999999">{{
                    item.status == 0
                      ? "待支付"
                      : item.status == 1
                      ? "已支付"
                      : item.status == 2
                      ? "已退款"
                      : ""
                  }}</span>
                </div>
              </template>

              <div
                style="width: 100%; height: auto; text-align: center"
                v-if="noMore"
                @click="ordersFetch('more')"
              >
                查看更多
              </div>
              <div
                style="width: 100%;color: #666666; height: auto; text-align: center"
                v-else
              >
                暂无更多
              </div>
            </div>
          </div>

          <div v-show="actType == 6" class="gywm">
            成都金马驹文化科技有限公司成立于2022年12月19日，致力于原创漫画制作、原创动画制作以及动漫平台打造等业务，团队主要以孵化IP故事为核心业务；动画团队目前拥有全流程动画制作团队，主要开发原创短视频动画IP，将动漫作品制作完成后上架至动漫平台，供广大动漫爱好者观看。
          </div>
          <div v-show="actType == 4">
            <div class="kf-info">
              <p>客服电话：010-686 23209</p>
              <p>客服工作时间：上午10:00-12:00 下午13:00-19:00</p>
            </div>
            <p class="kf-desc">
              关注客服公众号，在对话框内输入您在阅读过程中想了解的内容
              热情耐心的客服小助理将火速赶到，竭诚为您解答
            </p>
          </div>
        </div>
      </div>
      <!--		开通会员弹窗-->
      <payModel
        :numberTip="numberTip"
        @openNpmber="openNpmber"
        v-if="numberTip"
      ></payModel>
    </div>
  </div>
</template>

<script>
import Model from "@/components/dialog/index";
import payModel from "@/components/payModel/index";
import { ordersList, orderStatus } from "@/api/login";
import { removeToken } from "@/utils/utils";
import json from "./data.json";
export default {
  components: {
    Model,
    payModel,
  },
  data() {
    return {
      modelShow: false,
      qdnum: 0, //0注销 1登录
      userInfo: {},
      menuList: [
        {
          name: "用户协议",
          type: 1,
          img: require("../../assets/userprivacy2.png"),
          aimg: require("../../assets/userprivacy.png"),
        },
        {
          name: "隐私协议",
          type: 2,
          img: require("../../assets/privacy2.png"),
          aimg: require("../../assets/privacy.png"),
        },
        {
          name: "退款协议",
          type: 7,
          img: require("../../assets/refund2.png"),
          aimg: require("../../assets/refund.png"),
        },
        {
          name: "自审制度",
          type: 8,
          img: require("../../assets/selftrial.png"),
          aimg: require("../../assets/selftrial2.png"),
        },
        {
          name: "充值记录",
          type: 3,
          img: require("../../assets/icon_xiaofeijilu.png"),
          aimg: require("../../assets/pay-active.png"),
        },
        {
          name: "关于我们",
          type: 6,
          img: require("../../assets/myself.png"),
          aimg: require("../../assets/my.png"),
        },
        {
          name: "联系我们",
          type: 4,
          img: require("../../assets/icon_lianxikefu.png"),
          aimg: require("../../assets/erji.png"),
        },
        {
          name: "注销账号",
          type: 5,
          img: require("../../assets/icon_zhuxiaozhanghu.png"),
          aimg: require("../../assets/icon_zhuxiaozhanghu.png"),
        },
      ],
      actType: 1,
      oldactType: 1,
      hisList: [],
      numberTip: false, //会员付款弹窗
      priceList: [], //会员价格列表
      ordersList: [], //消费列表
      payPrice: 0,
      aliform: "", //支付宝表单
      listPage: 1, //初始化页码
      listSize: 10, //每页条数
      noMore: false, //控制是否显示暂无更多
      selfTrial: {},
    };
  },
  mounted() {
    console.log(json, "json");
    this.selfTrial = json.selfTrial;
    // historyfoApi().then((res)=>{
    // 	this.hisList = res
    // })
    let info = JSON.parse(localStorage.getItem("info"));
    this.userInfo = info.data;
    if (this.GetRequest2("out_trade_no")) {
      //如果订单号存在
      orderStatus({ id: this.GetRequest2("out_trade_no") }).then((res) => {
        if (res.paid || res.paid == "true") {
          this.getUserInfo();
        }
      });
    }
  },

  methods: {
    qiehuan() {
      //切换
      this.qdnum = 2;
      this.modelShow = true;
    },
    tuichu() {
      // 退出
      removeToken();
      localStorage.removeItem("info");
      this.$router.push({ name: "home" });
    },
    openNpmber() {
      if (this.numberTip == false) {
        this.numberTip = true;
      } else {
        this.numberTip = false;
      }
    },
    GetRequest2(key) {
      var url = location.search;
      var theRequest = new Object();
      let strs = "";
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      var value = theRequest[key];
      return value;
    },
    ordersFetch(e) {
      let page; //页码
      let size = this.listSize; //每页条数
      if (e == "more") {
        page = this.listPage + 1;
        this.listPage = page;
        size = this.listSize;
      } else {
        page = this.listPage;
        size = this.listSize;
      }

      ordersList({ page: page, size: size }).then((res) => {
        if (res.code == 4010) return;
        // if(res.data.length >= this.listSize)
        // {
        // 	this.noMore = false
        // }
        // else
        // {
        // 	this.noMore = true
        // }
        this.noMore = res.data.more;
        if (res.data.page == 1) {
          this.ordersList = res.data.data;
        } else {
          this.ordersList = this.ordersList.concat(res.data.data);
        }
      });
    },

    handleLogin(val) {
      this.qdnum = 1;
      this.modelShow = val;
    },
    clickEven() {},
    handleChange(type) {
      if (type == 7) {
        this.actType = type;
      } else if (type == 8) {
        this.actType = type;
      } else if (type == 6) {
        this.actType = type;
      } else if (type == 1) {
        this.actType = type;
      } else if (type == 2) {
        this.actType = type;
      } else if (type == 3) {
        //消费记录
        this.actType = type;
        this.listPage = 1;
        this.ordersFetch();
      } else if (type == 4) {
        //联系客服 缺少选中icon
        this.actType = type;
      } else if (type == 5) {
        this.qdnum = 0;
        this.modelShow = true;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.vipSty {
  width: 100%;
  height: auto;
  text-align: center;
}
/*!*观看历史*! 收藏记录*/
@media screen and (min-width: 1920px) {
  .mine-theater__item {
    width: 100%;
  }
}
.liItem {
  display: flex;
  flex-wrap: wrap;
  margin: -30px -10px;
}
.mine-theater__item {
  padding: 30px 10px;
  cursor: pointer;
  width: 100%;
  position: relative;
  box-sizing: border-box;
  &:hover {
    .mine-theater__title {
      color: red !important;
    }
  }
}
.mine-theater__cover {
  width: 100%;
  height: 0;
  padding-top: 133.33%;
  background: #f8f8f8;
  margin-bottom: 20px;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
}
.mine-theater__cover img {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.mine-theater__episode {
  height: 40px;
  line-height: 40px;
  font-size: 20px;
  color: #ffffff;
  background: #999999;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  padding: 0 16px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.mine-theater__title {
  line-height: 1;
  font-size: 24px;
  font-weight: 600;
  color: #333333;
}
.mine-theater__desc {
  line-height: 1.3;
  font-size: 16px;
  color: #888888;
  margin-top: 7px;
}
/*消费记录*/
.PayList {
  align-items: center;
}
.PayList .item {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}
.PayList .item span:nth-child(1) {
  width: 18%;
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  padding: 28px 46px;
  box-sizing: border-box;
}
.PayList .item span:nth-child(2) {
  width: 18%;
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  padding: 28px 46px;
  box-sizing: border-box;
}
.PayList .item span:nth-child(3) {
  width: 28%;
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  padding: 28px 46px;
  box-sizing: border-box;
}
.PayList .item span:nth-child(4) {
  width: 18%;
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  padding: 28px 46px;
  box-sizing: border-box;
}
.PayList .item span:nth-child(5) {
  width: 18%;
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  padding: 28px 46px;
  box-sizing: border-box;
}
/*消费记录*/
/*会员弹窗样式*/
.pay_tips {
  width: 100%;
  height: 100%;
  /*background: red;*/
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
.pay_tips_bg {
  width: 100%;
  height: 100%;
  /*background: red;*/
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
}
.pay_tips_content {
  width: 880px;
  background: #ffffff;
  position: relative;
  z-index: 20;
}
.app-header__vip-close {
  position: absolute;
  top: 17px;
  right: 17px;
  width: 21px;
  height: 21px;
  cursor: pointer;
}
.app-header__vip-close img {
  width: 100%;
  height: 100%;
}
.app-header__vip-header {
  height: 140px;
  padding: 0 32px;
  background: #fff4d9;
  display: flex;
  align-items: center;
}
.app-header__vip-avater {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  margin-right: 12px;
}
.app-header__vip-title {
  font-size: 24px;
  color: #b88723;
}
.app-header__vip-body {
  padding: 25px 20px 88px;
}
.app-header__vip-goods {
  display: flex;
  flex-wrap: wrap;
  margin: -10px -10px 30px;
}
.app-header__vip-goods-item {
  margin: 10px;
  width: 150px;
  height: 130px;
  border: 2px solid #d8b55c;
  border-radius: 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.app-header__vip-goods-name {
  line-height: 1;
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 20px;
}
.app-header__vip-goods-price {
  line-height: 1;
  font-weight: 600;
  color: #d8b55c !important;
  display: flex;
  align-items: flex-end;
}
.app-header__vip-goods-value {
  font-size: 36px;
}
.app-header__vip-payment {
  border: 2px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  align-items: stretch;
}
.app-header__vip-payment-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 60px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.app-header__vip-payment-btn {
  height: 60px;
  background: #469de2;
  border-radius: 30px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  line-height: 1.4;
  display: flex;
  align-items: center;
  padding: 0 43px;
  cursor: pointer;
}
.app-header__vip-payment-btn-text {
  display: flex;
  align-items: flex-end;
}
.app-header__vip-payment-btn img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}
.app-header__vip-payment-value {
  line-height: 1;
  font-size: 30px;
  padding: 0 8px;
}
.is-select {
  background-color: #d8b55c;
  color: #ffffff !important;
}
.is-select .app-header__vip-goods-name {
  color: #ffffff !important;
}
.is-select .app-header__vip-goods-price .app-header__vip-goods-unit {
  color: #ffffff !important;
}
.is-select .app-header__vip-goods-price .app-header__vip-goods-value {
  color: #ffffff !important;
}
/*会员弹窗样式end*/
.users {
//   min-width: 1200px;
  background-color: #ffffff;

}
.user2{
    min-width: 1200px;
  padding: 36px 10px 80px 160px;
  background-color: #ffffff;

}
.container {
    display: flex;
  width: 100%;
  margin: 0 auto;
}
/* 用户中心 */
.user-left {
  width: 300px;
  height: 100%;
  background: #f8f8f8;
  border-radius: 8px;
  margin-right: 30px;
  min-height: 500px;
  padding: 0 20px 90px;
  .avatar {
    width: 100%;
    height: 150px;
    padding: 40px 0 20px;
    position: relative;
    .avatar-holder {
      width: 90px;
      height: 90px;
      border-radius: 100px;
      margin: 0 auto;
      display: block;
      background: url("../../assets/img_touxiang.png") no-repeat center center/100%
        100%;
    }
  }
  .user-name {
    display: flex;
    justify-content: center;
    align-content: center;
    font-size: 26px;
    font-weight: 500;
    color: #333333;
    margin-bottom: 10px;
  }
  .user-des {
    font-size: 14px;
    color: #666666;
    margin-bottom: 30px;
    text-align: center;
  }
  .user-opt {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    span {
      font-size: 16px;
      font-weight: 500;
      color: #333333;
      /*co*/
      cursor: pointer;
    }
    span:first-child {
      margin-right: 38px;
    }
  }
  .user-btn {
    width: 148px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    background: #dbb85d;
    border-radius: 22px;
    margin: 0 auto 30px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    cursor: pointer;
  }

  .menus {
    li {
      position: relative;
      display: flex;
      align-items: center;
      padding: 20px 3px;
      border-bottom: 1px solid #dfdfdf;
      img {
        width: 30px;
        height: 30px;
        margin-right: 12px;
      }
      p {
        font-size: 20px;
        font-weight: 400;
        color: #333333;
      }
      color: #999999;

      cursor: pointer;
      &:hover {
        :before {
          height: 40%;
        }
      }
      :before {
        position: absolute;
        left: -20px;
        top: 30%;
        display: block;
        content: "";
        width: 2px;
        height: 0;
        background-color: #ff2929;
        transition: all 0.3s;
      }
    }
    .item-active {
      p {
        color: #ff2929;
      }
    }
  }
}
.user-right {
  flex: 1;
  padding: 0 20px;
  min-height: 570px;
  .kf-info {
    width: 610px;
    height: 78px;
    border-radius: 10px;
    border: 2px solid #ff2a2a;
    padding: 12px 77px;
    margin: 445px auto 30px;
    p {
      font-size: 20px;
      font-weight: 400;
      color: #ff2a2a;
      line-height: 28px;
      text-align: center;
    }
  }
  .kf-desc {
    width: 504px;
    height: 50px;
    font-size: 18px;
    font-weight: 400;
    color: #999999;
    line-height: 25px;
    margin: 0 auto;
    text-align: center;
  }
}
.his-no{
    position absolute;
    left:60%
    top:45%
    color: #666666;

}
.gywm{
  color:black;
  width 50%
  font-size:20px
  line-height: 50px
  margin: 445px auto 30px;

}
.act-title{
  text-align: center
}
</style>
